module.exports = __webpack_public_path__ + "static/media/price_bg.fb692b2f.png";